import React, { FC } from "react";
import EntityTextVisual from "./EntityTextVisual";
import useEntityAnnotation from "../../../../configMap/hooks/useEntityAnnotation";
import { GroupBlockEntityType } from "../../../../configMap";
import { EntityAnnotation } from "../../../../annotation";
import EntityValidation from "../../../../configMap/components/entity/EntityValidation";
import EditEntityText from "./EditEntityText";

export type TextEntityProps = {
  entityType: GroupBlockEntityType;
  entityAnnotation: EntityAnnotation;
  isEditing: boolean;
  isAnnotating: boolean;
  groupBlockIndex: number;
  documentId?: string;
  isTableMode?: boolean;
  // SideControls specific props
  showLabels?: boolean;
  isEditable?: boolean;
  showNormalizedValue?: boolean;
  requiresAttention?: boolean;
  // TableControls specific props
  cellClasses?: string;
};

const TextEntity: FC<TextEntityProps> = ({
  entityType,
  entityAnnotation,
  isEditing,
  isAnnotating,
  groupBlockIndex,
  documentId,
  isTableMode = false,
  showLabels = true,
  isEditable = true,
  showNormalizedValue = true,
  requiresAttention = false,
  cellClasses = "",
}) => {
  const { value, normalizedValue, options, errorType } =
    useEntityAnnotation(entityAnnotation);

  if (!entityAnnotation) {
    return null;
  }

  if (documentId && isEditing && !isAnnotating && isEditable) {
    return (
      <>
        <EditEntityText
          entityType={entityType}
          documentId={documentId}
          defaultValue={normalizedValue ?? value}
          annotationId={entityAnnotation.id!}
          groupBlockIndex={groupBlockIndex}
          isTableMode={isTableMode}
        />
        {isEditable && !isTableMode && (
          <EntityValidation
            validationId={`${entityType.entityType.id}-${groupBlockIndex}`}
            value={value}
            normalizedValue={normalizedValue}
            validations={[]}
            options={options}
            errorMessage={
              entityAnnotation.entityAnnotationNormalization?.errorMessage
            }
            errorType={errorType}
          />
        )}
      </>
    );
  }

  return (
    <>
      <EntityTextVisual
        value={value}
        normalizedValue={normalizedValue}
        showLabels={showLabels}
        showNormalizedValue={showNormalizedValue}
        requiresAttention={requiresAttention}
        errorType={errorType}
        cellClasses={cellClasses}
        isTableMode={isTableMode}
      />
      {isEditable && !isTableMode && (
        <EntityValidation
          validationId={`${entityType.entityType.id}-${groupBlockIndex}`}
          value={value}
          normalizedValue={normalizedValue}
          validations={[]}
          options={options}
          errorMessage={
            entityAnnotation.entityAnnotationNormalization?.errorMessage
          }
          errorType={errorType}
        />
      )}
    </>
  );
};

export default TextEntity;
